:host {
  display: block;
}

a {
  overflow: hidden;
  max-width: 23ch;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;

  span {
    font-family: var(--primary-font);
    font-weight: 400;
    font-size: 10px;
    color: var(--color-nero);
    line-height: 20px;
    text-transform: uppercase;
   
  
  
    @include breakpointMin('md') {
      font-size: 14px;
    }
  }
}
